import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { EUFinanceReactQueryKey } from "../../../../models/EUFinanceReactQueryKey";
import { useEUFinanceFileStoreService } from "../../services/EUFinanceFileStoreService";

export type UseAllowedMimeTypeToExtensionsMapResult = UseQueryResult<
  Record<string, string[]>
>;

const useAllowedMimeTypeToExtensionsMap =
  (): UseAllowedMimeTypeToExtensionsMapResult => {
    const fileStoreService = useEUFinanceFileStoreService();

    return useQuery<Record<string, string[]>>({
      queryKey: EUFinanceReactQueryKey.GET_ALLOWED_MIME_TYPE_TO_EXTENSIONS_MAP,
      queryFn: () => fileStoreService.getAllowedMimeTypeToExtensionsMap(),
      meta: {
        errorMessage: "Failed to get allowed mime type to extensions map",
      },
    });
  };

export default useAllowedMimeTypeToExtensionsMap;
